const KEY = "aleph-tracking";

export type Tracking = {
  utm_source: string | null;
  utm_medium: string | null;
  utm_campaign: string | null;
  utm_term: string | null;
  utm_content: string | null;
  gclid: string | null;
  fbclid: string | null;
  referrer: string | null;
  landing_page: string | null;
  page_path: string | null;
};

const EMPTY: Tracking = {
  utm_source: null,
  utm_medium: null,
  utm_campaign: null,
  utm_term: null,
  utm_content: null,
  gclid: null,
  fbclid: null,
  referrer: null,
  landing_page: null,
  page_path: null,
};

/** Reads UTMs/click ids from the URL on first visit and keeps them for the session. */
export function captureTracking(): Tracking {
  if (typeof window === "undefined") return EMPTY;
  const params = new URLSearchParams(window.location.search);
  const pick = (name: string) => {
    const value = params.get(name);
    return value && value.trim().length > 0 ? value.trim().slice(0, 300) : null;
  };

  const fromUrl: Tracking = {
    utm_source: pick("utm_source"),
    utm_medium: pick("utm_medium"),
    utm_campaign: pick("utm_campaign"),
    utm_term: pick("utm_term"),
    utm_content: pick("utm_content"),
    gclid: pick("gclid"),
    fbclid: pick("fbclid"),
    referrer: document.referrer ? document.referrer.slice(0, 500) : null,
    landing_page: window.location.href.slice(0, 500),
    page_path: window.location.pathname,
  };

  let stored: Partial<Tracking> = {};
  try {
    stored = JSON.parse(window.sessionStorage.getItem(KEY) ?? "{}") as Partial<Tracking>;
  } catch {
    stored = {};
  }

  const hasNewCampaign = Boolean(
    fromUrl.utm_source || fromUrl.utm_campaign || fromUrl.gclid || fromUrl.fbclid,
  );
  const merged: Tracking = hasNewCampaign
    ? fromUrl
    : {
        ...EMPTY,
        ...stored,
        referrer: stored.referrer ?? fromUrl.referrer,
        landing_page: stored.landing_page ?? fromUrl.landing_page,
        page_path: fromUrl.page_path,
      };

  try {
    window.sessionStorage.setItem(KEY, JSON.stringify(merged));
  } catch {
    /* storage unavailable */
  }
  return merged;
}
